module.exports = __webpack_public_path__ + "files/45aaa5579c670a734ae7da4561d3ee53.svg";